import { render, staticRenderFns } from "./SearchRecentlyConsulted.vue?vue&type=template&id=43ec58c1&scoped=true&"
import script from "./SearchRecentlyConsulted.vue?vue&type=script&lang=js&"
export * from "./SearchRecentlyConsulted.vue?vue&type=script&lang=js&"
import style0 from "./SearchRecentlyConsulted.vue?vue&type=style&index=0&id=43ec58c1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43ec58c1",
  null
  
)

export default component.exports